var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#3BA1E5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2031 34.7999V32.4C13.2031 31.1269 13.7088 29.906 14.609 29.0058C15.5092 28.1057 16.7301 27.6 18.0031 27.6H22.8031C24.0762 27.6 25.2971 28.1057 26.1972 29.0058C27.0974 29.906 27.6031 31.1269 27.6031 32.4V34.7999M28.8031 13.356C29.8356 13.6203 30.7508 14.2208 31.4043 15.0627C32.0578 15.9047 32.4125 16.9402 32.4125 18.006C32.4125 19.0718 32.0578 20.1073 31.4043 20.9492C30.7508 21.7911 29.8356 22.3916 28.8031 22.656M34.8031 34.8V32.4C34.797 31.3406 34.4406 30.3129 33.7894 29.4773C33.1383 28.6416 32.2289 28.0448 31.2031 27.78M15.6031 18C15.6031 19.273 16.1088 20.4939 17.009 21.3941C17.9092 22.2942 19.1301 22.8 20.4031 22.8C21.6762 22.8 22.8971 22.2942 23.7972 21.3941C24.6974 20.4939 25.2031 19.273 25.2031 18C25.2031 16.7269 24.6974 15.506 23.7972 14.6058C22.8971 13.7057 21.6762 13.2 20.4031 13.2C19.1301 13.2 17.9092 13.7057 17.009 14.6058C16.1088 15.506 15.6031 16.7269 15.6031 18Z",
    stroke: "#2E86C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.daeda6ae9a29eb926c611499de9fc610.svg";
export { ForwardRef as ReactComponent };